import { formatUnitPrice } from "services/api/pricing/consts";
import { PricingSchemeTenantImpact } from "services/api/pricing/schemeTypes";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const SCHEME_IMPACT_COLUMNS: Column[] = [
  {
    title: "Klijent",
    field: "tenantName",
    sortable: true,
    type: ColumnTypes.string,
  },
  {
    title: "Vozila",
    field: "vehicleCount",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingSchemeTenantImpact) => (
      <span className="text-slate-500">{row.vehicleCount}</span>
    ),
  },
  {
    title: "Mjesečni učinak",
    field: "monthlyEffect",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingSchemeTenantImpact) => (
      <span className="font-semibold text-slate-700 whitespace-nowrap">
        {formatUnitPrice.format(row.monthlyEffect)}
      </span>
    ),
  },
];
